var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:_vm.class_input,attrs:{"type":"text","readonly":_vm.modo_calc !== 'amount'},domProps:{"value":_vm.displayValue},on:{"change":_vm.onBlur,"input":_vm.onInput,"click":_vm.onFocus,"focusin":_vm.onFocus,"mousedown":function($event){$event.preventDefault();},"blur":_vm.onOut}})
}
var staticRenderFns = []

export { render, staticRenderFns }